import { handleActions } from 'redux-actions'

import {
  archiveProductRequest,
  archiveProductSucceed,
  clearProductDetail,
  createProductRequest,
  createProductSucceed,
  getCompanyProductListRequest,
  getCompanyProductListSucceed,
  getProductDetailRequest,
  getProductDetailSucceed,
  requestFailure,
  updateProductRequest,
  updateProductSucceed
} from './actions'

export const INITIAL_STATE = {
  processing: {
    getProductList: false,
    getProductDetail: false,
    createOrUpdatingProduct: false
  },
  productList: null,
  productDetail: null
}

type State = typeof INITIAL_STATE

export const productReducer = handleActions<State, any>(
  {
    [getCompanyProductListRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getProductList: true
      }
    }),
    [getCompanyProductListSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getProductList: false
      },
      productList: payload
    }),
    [getProductDetailRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getProductDetail: true
      }
    }),
    [getProductDetailSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getProductDetail: false
      },
      productDetail: payload
    }),
    [createProductRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingProduct: true
      },
      productDetail: null
    }),
    [createProductSucceed.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingProduct: false
      }
    }),
    [updateProductRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingProduct: true
      },
      productDetail: null
    }),
    [updateProductSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingProduct: false
      },
      productDetail: payload
    }),
    [archiveProductRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingProduct: true
      }
    }),
    [archiveProductSucceed.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingProduct: false
      }
    }),
    [clearProductDetail.toString()]: (state) => ({
      ...state,
      productDetail: null
    }),
    [requestFailure.toString()]: (state) => ({
      ...state,
      processing: INITIAL_STATE.processing
    })
  },
  INITIAL_STATE
)
